import styled from "styled-components"
import { device } from "../../theme/device"

export const Price = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: 0;
  height: 100px;
  width: 100%;
  background-color: #f1f1f1;
  color: #7c9590;
  padding: 0.5em;
  font-family: NewParisKingSize-Regular;
  font-size: 3.5em;
  font-weight: 100;
  letter-spacing: 0.1em;
`

export const PlanFavouriteContainer = styled.div`
  width: 30vw;
  min-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  @media ${device.mobileL} {
    width: 95vw;
    min-width: 350px;
  }
`

export const FloorPlan = styled.div`
  width: 100%;
  min-height: 450px;
  background-color: #f1f1f1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 4;
`

export const InfoHolder = styled.div`
  border-top: #94293d;
  flex: 2;
  display: flex;
  background-color: #7c9590;
  padding: 1vw;
  gap: 2vw;
`

export const Dimensions = styled.div`
  flex: 2;
  flex-basis: 1;
  background-image: ${({ image }) => `url(${image})`};
  background-position: left center;
  background-size: contain;
  background-repeat: no-repeat;
`

export const TitleHolder = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const Level = styled.div`
  padding-left: 1em;
  font-family: NewParisKingSize-Regular;
  font-size: 2.5em;
  font-weight: 100;
  color: #f5f5f5;
  position: relative;
  &:before {
    content: "LEVEL";
    font-size: 0.3em;
    color: #767474;
    font-family: AzoSans-Regular;
    position: absolute;
    top: 1em;
    left: 0;
    z-index: 1;
  }
`
export const ApartID = styled.div`
  padding-left: 0.2em;
  font-family: NewParisKingSize-Regular;
  font-size: 1.5em;
  font-weight: 100;
  color: #536866;
  position: relative;
  display: flex;
  align-items: flex-end;
  &:before {
    content: "Apartment";
    padding-right: 0.2em;
  }
`
export const RoomType = styled.div`
  padding-left: 0.2em;
  font-family: OuterSans-Regular;
  font-size: 1vw;
  font-weight: 400;
  color: #d0d1d0;
  position: relative;
  display: flex;
  margin-bottom: 0.8em;
  text-transform: uppercase;
`
export const Button = styled.button`
  pointer-events: initial;
  cursor: pointer;
  flex: 1;
  padding: 1em;
  font-family: AzoSans-Regular;
  font-size: 1em;
  text-transform: uppercase;
  text-align: center;
  color: white;
  background-color: ${({ color }) => color};
  border: none;
  outline: none;
`
export const CompasImage = styled.img`
  margin: 1vw;
  width: 4vw;
`
